<div id="{{position}}" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <header class="app-header-background inline-gradient"
      [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="app-header-section pt-20 global-max-width">
        <div class="app-header-headline form-headline center" [attr.data-aos]="textAnimation ? textAnimation : null">
          <h1 [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }" class="mat-h1"
            [innerHtml]="title | safeHtml" [ngClass]="[titleSize]">
          </h1>
          <h2 [ngStyle]="{ 'color': textColor }" [innerHtml]="text | safeHtml" [class]="textSize"> </h2>
        </div>
        <div class="app-header-start" [attr.data-aos]="buttonAnimation ? buttonAnimation : null"
          *ngIf="buttonText && buttonsDisplay!=0">
          <ng-container *ngIf="buttonLink && buttonLink.includes('#') && buttonLink.length<5; else externalLink">
            <a class="app-button mat-raised-button"
              [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
              [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
              mat-raised-button (click)='navigateTo(buttonLink)' rel="noopener">
              <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
              <span class="mat-button-wrapper"> {{ buttonText }} </span>
            </a>
          </ng-container>
          <ng-template #externalLink>
            <a class="app-button mat-raised-button"
              [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
              [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor ? (buttonStyle == 'style3'? (buttonBackgroundColor?buttonBackgroundColor:'var(--accent)') : buttonTextColor) : '#ffffff'}"
              mat-raised-button style="cursor: pointer" (click)="clickExternalLink(buttonLink)"
              [href]="buttonLink | safeUrl" target="_blank" rel="noopener">
              <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
              <span class="mat-button-wrapper"> {{ buttonText }} </span>
            </a>
          </ng-template>
          <span *ngIf="secondButtonText && buttonsDisplay==2">
            <ng-container
              *ngIf="secondButtonLink && secondButtonLink.includes('#') && secondButtonLink.length<5; else externaseceondlLink">
              <a class="app-button mat-raised-button second-button" mat-raised-button
                [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor ? (buttonStyle == 'style3'? (buttonBackgroundColor?buttonBackgroundColor:'var(--accent)') : buttonTextColor) : '#ffffff'}"
                (click)='navigateTo(secondButtonLink)' rel="noopener">
                <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                  {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
              </a>
            </ng-container>
            <ng-template #externaseceondlLink>
              <a class="app-button mat-raised-button second-button" mat-raised-button style="cursor: pointer"
                [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor ? (buttonStyle == 'style3'? (buttonBackgroundColor?buttonBackgroundColor:'var(--accent)') : buttonTextColor) : '#ffffff'}"
                (click)="clickExternalLink(secondButtonLink)" [href]="secondButtonLink | safeUrl" target="_blank"
                rel="noopener">
                <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                  {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
              </a>
            </ng-template>
          </span>
        </div>
      </div>
    </header>
  </div>
</div>
<style *ngIf="buttonStyle == 'style3' || buttonStyle == 'style2'">
  .style3:hover {
    color: var(--button-color-cta) !important;
    background-color: var(--button-background-cta) !important;
  }

  .style2:hover {
    color: var(--button-color-cta) !important;
    background-color: var(--button-background-cta) !important;
  }
</style>